import { FETCH_TYPES } from "../../actions/sql/constants";
import { SUCCESS, FAILURE, PENDING } from "../../actions/constants";

const initialState = {
  data: [],
  byGroupName: {
    Make: {
      groupInfo: {},
      types: []
    },
    Model: {
      groupInfo: {},
      types: []
    },
    Trim: {
      groupInfo: {},
      types: []
    },
    "Creative Agency": {
      groupInfo: {},
      types: []
    },
    Strategy: {
      groupInfo: {},
      types: []
    },
    "Retail Offer Type": {
      groupInfo: {},
      types: []
    },
    "Creative Unit": {
      groupInfo: {},
      types: []
    },
    Format: {
      groupInfo: {},
      types: []
    },
    Country: {
      groupInfo: {},
      types: []
    },
    Language: {
      groupInfo: {},
      types: []
    },
    "Creative Version": {
      groupInfo: {},
      types: []
    },
    Dimensions: {
      groupInfo: {},
      types: []
    },
    "Creative Display": {
      groupInfo: {},
      types: []
    }
  },
  allGroupNames: [],
  isLoading: false
};

const normalizeDataByGroup = data => {
  let byGroupName = {};
  let allGroupNames = [];

  for (let i = 0; i < data.length; i++) {
    let group = data[i];
    byGroupName[group.groupInfo.Type_Group_UI_Name] = { ...group };
    allGroupNames.push(group.groupInfo.Type_Group_UI_Name);
  }

  return { byGroupName, allGroupNames };
};

export const typeGroups = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TYPES:
      switch (action.status) {
        case SUCCESS:
          let { byGroupName, allGroupNames } = normalizeDataByGroup(
            action.typeGroups
          );
          return {
            byGroupName: { ...byGroupName },
            allGroupNames: [...allGroupNames],
            isLoading: false
          };
        case FAILURE:
          return {
            byGroupName: { ...state.byGroupName },
            allGroupNames: [...state.allGroupNames],
            isLoading: false
          };
        case PENDING:
          return {
            byGroupName: { ...state.byGroupName },
            allGroupNames: [...state.allGroupNames],
            isLoading: true
          };
        default:
          return state;
      }
    default:
      return state;
  }
};
